/* eslint-disable no-self-assign */
// React imports
import { useState, useMemo, useEffect } from 'react';
import { useOutletContext, useNavigate, useLocation, useSearchParams } from 'react-router-dom';

// Generic imports
import _ from 'lodash';
import pluralize from 'pluralize';
import axios from 'axios';

// Material UI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

// Font Awesome imports
import { faCalculator, faPlus } from '@fortawesome/pro-light-svg-icons';

// Local imports
import Header from '../../Header.js';
import AutoPricingRow from './AutoPricingRow.js';

function AutoPricingMain(props) {
    const { org, autoPricings, onUpdateAutoPricing, accounts, accesstoken, me } = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();

    function onOpen({ autoPricing, newWindow }) {
        if (newWindow) {
            if (!location.pathname || location.pathname.length < 2) {
                window.open(`https://app.monada.ai/organization/${org.alias}/auto-pricing/${autoPricing.id}/?accesstoken=${encodeURIComponent(accesstoken.monada)}`, '_blank');
            } else {
                window.open(`${location.pathname.replace(/\/main/, '')}/${autoPricing.id}/?${location.search}`.replace(/\/\//g, '/'), '_blank');
            }
        } else {
            navigate(`/organization/${org.alias}/auto-pricing/${autoPricing.id}/`);
        }
    }

    const mainAutoPricings = _.sortBy(autoPricings.filter(a => a.owner === me.email), r => -1 * r.created);

    return (
        <Box sx={{ paddingBottom: '36px', background: '#fafbfc' }}>
            <Header
                icon={faCalculator}
                title={'Auto-Pricing'}
                buttons={[{
                    title: 'New Auto-Pricing',
                    icon: faPlus,
                    color: 'monada-button',
                    action: () => {
                        navigate(`/organization/${org.alias}/auto-pricing/new/`);
                    }
                }]}
            />
            <Box style={{ padding: '12px', paddingTop: '0px' }}>

                {(mainAutoPricings.length === 0) && (
                    <Box sx={{ paddingTop: '24px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant='body1' sx={{ marginBottom: '12px' }}>
                            Our system will automatically create quotes for you, based on available rates, and margins you set.
                        </Typography>
                        <Button variant='contained' color='monada-button' onClick={() => {
                            navigate(`/organization/${org.alias}/auto-pricing/new/`);
                        }} sx={{ marginTop: '12px' }}>
                            Create Your First Auto-Pricing
                        </Button>
                    </Box>
                )}
                {(mainAutoPricings.length > 0) && (
                    <Box>
                        <Paper sx={{ marginTop: '12px', border: `1px solid ${grey[300]}`, padding: '12px' }}>
                            <Typography variant='body2' component={Box} sx={{ display: 'inline-block' }}>
                                {mainAutoPricings.length.toLocaleString()}
                                {` automatic `}
                                {pluralize('pricing', mainAutoPricings.length)}
                            </Typography>
                        </Paper>
                        {mainAutoPricings.map((autoPricing, i) => (
                            <AutoPricingRow
                                key={autoPricing.id}
                                autoPricing={autoPricing}
                                onOpen={onOpen}
                                accounts={accounts}
                                emails={org.users.map(u => u.email)}
                            />
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default AutoPricingMain;